/* ============================================================
   naturism Experience Layer JS — prototype v4 port (2026-06-11)
   - index(ホーム)のみで読み込まれる(theme.liquid)
   - 依存: ne-vendor-gsap.js / ne-vendor-scrolltrigger.js / ne-vendor-lenis.js(全てdefer・先行)
   - GSAP不在時は即returnし、CSSはnx-js無しの素の状態(全要素可視)で成立する
   - ⚠️ピン留めセクションより下のScrollTriggerはピンスペーサー分ズレるため
     セットアップ末尾+window.load+fonts.readyで ScrollTrigger.refresh() 必須
   ============================================================ */
(function () {
  'use strict';
  if (!window.gsap || !window.ScrollTrigger) return;
  /* JS有効の印(これが無いとCSSは「全部見える」素の状態=ノーJSフォールバック) */
  document.documentElement.classList.add('nx-js');

  /* ---- nxLazy: fold下セクションの重い初期化を「近づいてから」に遅らせる(2026-08-24 T-3a) ----
     背景: LoAF(Long Animation Frame)+CPU4x の実測で ne-experience.js の同期パスは 607ms。
     うち 265ms(44%)が customer's voice の gsap.from() 2本。対象は .nx-vbubble 34 + .nx-star 156 の190要素で、
     gsap.from() はセレクタ解決時に全要素の算出スタイルを読むため、強制レイアウトが初期ロードに乗っていた。
     当該演出の ScrollTrigger start は 'top 78%' / 'top 72%' ＝画面に近づくまで何もしない。
     rootMargin を1.5画面分取り、実発火よりはるかに手前で生成するので見た目は不変(実測で確認済)。
     IntersectionObserver 非対応環境は即時実行にフォールバック。
     ⚠️呼び出し側が要素の存在を保証すること。root が無い状態で init() を走らせると
       「gsap.from が opacity:0 を書いたのに ScrollTrigger の trigger が見つからず永久に出ない」
       事故になる(Codexレビュー#T3a HIGH指摘)。そのため el 不在時は**何もしない**。 */
  var nxLazy = function (el, init) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) {
      init();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (e) {
            return e.isIntersecting;
          })
        )
          return;
        io.disconnect();
        init();
        /* ⚠️ScrollTrigger.refresh() は呼ばない: 全トリガー(30本超)の再測定でスクロール中に
         大きな強制レイアウトとジャンプを起こす。新規 ScrollTrigger は自分で start/end を計算する。 */
      },
      { rootMargin: '150% 0px 150% 0px' },
    );
    io.observe(el);
  };

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(pointer: fine)').matches;
  gsap.registerPlugin(ScrollTrigger);

  /* ---- Lenis慣性スクロール(ドロワー類はネイティブスクロール維持) ---- */
  var lenis = null;
  if (!reduce && window.Lenis) {
    lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) {
      lenis.raf(t * 1000);
    });
    gsap.ticker.lagSmoothing(0);
    ['cart-drawer', 'cart-notification', 'menu-drawer', 'details-modal', 'predictive-search'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.setAttribute('data-lenis-prevent', '');
      });
    });
  }

  /* ---- intro curtain(セッション1回のみ) ---- */
  var curtain = document.querySelector('.nx-curtain');
  var intro = gsap.timeline();
  var showCurtain = false;
  try {
    showCurtain = !sessionStorage.getItem('nxCurtain');
  } catch (e) {
    /* storage不可なら毎回 */ showCurtain = true;
  }
  if (curtain && showCurtain && !reduce) {
    try {
      sessionStorage.setItem('nxCurtain', '1');
    } catch (e) {}
    intro
      .to('.nx-curtain__logo', { opacity: 1, duration: 0.45, ease: 'power2.out' })
      .to('.nx-curtain__logo', { opacity: 0, duration: 0.3, delay: 0.35 })
      .to(curtain, { yPercent: -100, duration: 0.75, ease: 'power4.inOut' })
      .set(curtain, { display: 'none' });
  } else if (curtain) {
    curtain.style.display = 'none';
  }

  /* ---- hero: 文字バラし+ロゴのスクロール退場 ----
     v2ヒーロー(ne-x-hero-v2)使用時は旧ヒーロー一式をno-op化(!heroV2ガード) */
  var heroV2 = document.querySelector('[data-nx-hero-v2]');
  var heroLogo = document.getElementById('nxHeroLogo');
  var heroH1 = document.getElementById('nxHeroH1');
  if (heroH1) {
    heroH1.innerHTML = heroH1.textContent
      .split('')
      .map(function (c) {
        return '<span class="nx-ch">' + (c === ' ' ? '&nbsp;' : c) + '</span>';
      })
      .join('');
  }
  if (heroLogo && !heroV2) {
    intro
      .from(heroLogo, { y: 36, opacity: 0, duration: 0.85, ease: 'power3.out' }, showCurtain && !reduce ? '-=0.4' : 0)
      .from('.nx-hero__tag', { y: 18, opacity: 0, duration: 0.55 }, '-=0.45')
      .from('#nxHeroH1 .nx-ch', { y: 24, opacity: 0, stagger: 0.022, duration: 0.65, ease: 'back.out(1.5)' }, '-=0.35')
      .from('.nx-hero__sub, .nx-hero__cue', { opacity: 0, y: 12, duration: 0.55, stagger: 0.1 }, '-=0.35')
      .from('.nx-hfloat', { scale: 0, opacity: 0, stagger: 0.08, duration: 0.75, ease: 'back.out(1.7)' }, '-=0.7');

    gsap
      .timeline({
        scrollTrigger: { trigger: '.nx-hero', start: 'top top', end: '65% top', scrub: true },
      })
      .to(heroLogo, { scale: 0.3, yPercent: -160, transformOrigin: '50% 0%', opacity: 0, ease: 'none' }, 0)
      .to('.nx-hero__tag', { opacity: 0, y: -36, ease: 'none' }, 0)
      .to('#nxHeroH1', { y: -52, ease: 'none' }, 0)
      .to('.nx-hero__sub', { opacity: 0, y: -26, ease: 'none' }, 0)
      .to('.nx-hfloat', { y: -110, stagger: 0.03, ease: 'none' }, 0);
  }

  /* ---- 深度パララックス ---- */
  document.querySelectorAll('.nx-hfloat, .nx-stmt__orbit').forEach(function (el) {
    var sp = parseFloat(el.dataset.speed || 1);
    gsap.to(el, {
      yPercent: -20 * sp,
      ease: 'none',
      scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true },
    });
  });

  /* ---- 題字: ブラー→悠然と(スクロール連動) ---- */
  gsap.utils.toArray('.nx-rv').forEach(function (el) {
    gsap.to(el, {
      opacity: 1,
      filter: 'blur(0px)',
      y: 0,
      ease: 'none',
      scrollTrigger: { trigger: el, start: 'top 92%', end: 'top 58%', scrub: true },
    });
  });

  /* ---- 曲線モーフ(カットイン→アウトギリギリのフルパスを往復・常に動いて目立つ・SNS帯の波も対象) ----
     旧: top96%→top28%で片道変形が画面中ほどで完了→以後は静止したまま退場(動きが止まって見えた)。
     新: 窓を視界通過の全域(top bottom→bottom top)へ拡張し、画面中央で∩へ最大反転→退場際に∪へ戻す往復に。
     登場から退場ギリギリまで動き続け、振れ幅が往復ぶん倍増して以前より明確に目立つ。 */
  gsap.utils.toArray('.nx-wave path[data-d2], .nx-sns__wave path[data-d2]').forEach(function (p) {
    var d1 = p.getAttribute('d');
    var host = p.closest('.nx-wave, .nx-sns__wave');
    gsap
      .timeline({
        defaults: { ease: 'sine.inOut' },
        scrollTrigger: { trigger: host, start: 'top bottom', end: 'bottom top', scrub: 0.6 },
      })
      .to(p, { attr: { d: p.dataset.d2 } })
      .to(p, { attr: { d: d1 } });
  });

  /* ---- 背景イメージ: ベール下でゆっくりズーム(スクラブ) ---- */
  document.querySelectorAll('[data-nx-bgzoom]').forEach(function (sec) {
    var img = sec.querySelector('.nx-bgwrap img');
    if (!img) return;
    gsap.fromTo(
      img,
      { scale: 1.04 },
      {
        scale: 1.14,
        ease: 'none',
        scrollTrigger: { trigger: sec, start: 'top bottom', end: 'bottom top', scrub: true },
      },
    );
  });

  /* ---- statement: 読むほど灯る ---- */
  var stText = document.getElementById('nxStText');
  if (stText) {
    stText.innerHTML = stText.textContent
      .split('')
      .map(function (c) {
        return '<span class="nx-w">' + (c === ' ' ? '&nbsp;' : c) + '</span>';
      })
      .join('');
    gsap.to('#nxStText .nx-w', {
      opacity: 1,
      stagger: 0.3,
      ease: 'none',
      scrollTrigger: { trigger: '.nx-stmt', start: 'top 72%', end: '55% 42%', scrub: true },
    });
  }

  /* ---- statement: 植物背景クロスフェード+パララックス(2026-07-10) ----
     白ミスト(CSS veil)越しに4景がスクロール進行でゆっくり入れ替わる。
     reduced-motionは1枚目固定(CSS :first-child)のまま何もしない。
     2枚目以降はセクション接近時にdata-src→srcで遅延取得。 */
  (function () {
    if (reduce) return;
    /* テーマエディタは静的(1枚目固定=CSS :first-child)。セクション再描画でも走らせない */
    if (window.Shopify && Shopify.designMode) return;
    var stSec = document.querySelector('.nx-stmt--botanic');
    if (!stSec) return;
    var bgImgs = gsap.utils.toArray(stSec.querySelectorAll('.nx-stmt__bgimg'));
    if (bgImgs.length < 2) return;
    var bgLoaded = false;
    function loadRest() {
      if (bgLoaded) return;
      bgLoaded = true;
      bgImgs.forEach(function (im) {
        if (im.dataset.src) {
          im.src = im.dataset.src;
          im.removeAttribute('data-src');
        }
      });
    }
    ScrollTrigger.create({
      trigger: stSec,
      start: 'top 130%' /* 画面1.3枚分手前で先読み(表示時には取得済み) */,
      once: true,
      onEnter: loadRest,
    });
    ScrollTrigger.create({
      trigger: stSec,
      /* 視界通過の全域を使い切って4景を配分(セクションが低くても入れ替わりが慌てない) */
      start: 'top bottom',
      end: 'bottom top',
      scrub: 0.9,
      onUpdate: function (self) {
        var p = self.progress,
          n = bgImgs.length;
        /* 端をクランプ: 進行の両端でも1枚目/最終枚が満開のまま(端で薄くならない) */
        var pc = Math.min(Math.max(p, 0.5 / n), 1 - 0.5 / n);
        bgImgs.forEach(function (im, i) {
          var c = (i + 0.5) / n; /* 各景の担当中心 */
          var d = Math.abs(pc - c) * n; /* 中心からの距離(景単位) */
          var op = Math.max(0, 1 - Math.max(0, d - 0.24) * 1.5); /* 中心±24%は全開→隣へ長めに溶ける */
          im.style.opacity = op.toFixed(3);
          /* パララックス: 各景が下から上へゆっくり流れる(top:-8%/height:116%の遊び内)。
             ±9%=2026-07-10チューニング(旧±5%は「効果が感じられない」とユーザー指摘)。
             最大シフト≈7.9%はscale(1.08)+CSS呼吸ズーム(合算の最大実効≈1.145)の拡大マージンで吸収 */
          im.style.transform = 'translateY(' + ((p - c) * -9).toFixed(2) + '%) scale(1.08)';
        });
      },
    });
  })();

  /* ---- series: ピン留め切替(淡色ブロブ+カードスワップ) ---- */
  var seriesPin = document.getElementById('nxSeriesPin');
  if (seriesPin) {
    var blob = document.getElementById('nxSeriesBlob');
    var names = gsap.utils.toArray('.nx-series__name');
    var caps = gsap.utils.toArray('.nx-series__cap');
    var prices = gsap.utils.toArray('.nx-series__price span');
    var scards = gsap.utils.toArray('.nx-scard');
    var dots = gsap.utils.toArray('.nx-series__dot');
    var idxEl = document.getElementById('nxSeriesIdx');
    var tints = scards.map(function (c) {
      return c.dataset.tint || '#E9F1F8';
    });
    var n = scards.length;
    if (n >= 2) {
      gsap.set(names.slice(1), { yPercent: 70, opacity: 0 });
      gsap.set(caps.slice(1), { yPercent: 70, opacity: 0 });
      gsap.set(prices.slice(1), { opacity: 0 });
      gsap.set(scards.slice(1), { yPercent: 14, opacity: 0, rotate: 3 });
      if (blob && tints[0]) blob.style.backgroundColor = tints[0];

      var sTl = gsap.timeline({
        scrollTrigger: {
          trigger: seriesPin,
          start: 'top top',
          end: '+=' + n * 63 + '%',
          scrub: 0.6,
          pin: true,
          onUpdate: function (self) {
            var i =
              n === 3
                ? self.progress < 0.38
                  ? 0
                  : self.progress < 0.76
                    ? 1
                    : 2
                : Math.min(n - 1, Math.floor(self.progress * n));
            dots.forEach(function (d, j) {
              d.classList.toggle('on', j === i);
            });
            if (idxEl) idxEl.textContent = '0' + (i + 1);
          },
        },
      });
      var swap = function (from, to, pos) {
        if (blob)
          sTl.to(
            blob,
            {
              backgroundColor: tints[to],
              rotate: to * 34 - 17,
              scale: 1 + to * 0.07,
              duration: 0.85,
              ease: 'power2.inOut',
            },
            pos,
          );
        sTl
          .to([names[from], caps[from]], { yPercent: -70, opacity: 0, duration: 0.4 }, pos)
          .to(prices[from], { opacity: 0, duration: 0.3 }, pos)
          .fromTo(
            [names[to], caps[to]],
            { yPercent: 70, opacity: 0 },
            { yPercent: 0, opacity: 1, duration: 0.4 },
            pos + 0.22,
          )
          .to(prices[to], { opacity: 1, duration: 0.3 }, pos + 0.35)
          .to(scards[from], { yPercent: -12, opacity: 0, rotate: -3, duration: 0.4 }, pos)
          .fromTo(
            scards[to],
            { yPercent: 14, opacity: 0, rotate: 3 },
            { yPercent: 0, opacity: 1, rotate: 0, duration: 0.45 },
            pos + 0.18,
          );
      };
      if (blob) gsap.to(blob, { scale: 1.04, duration: 5, yoyo: true, repeat: -1, ease: 'sine.inOut' });
      for (var s = 0; s < n - 1; s++) swap(s, s + 1, 0.5 + s * 1.05);
      sTl.to({}, { duration: 0.4 });
    }
  }

  /* ---- history: 12年史タイムライン・ショーケース(2026-07-07) ----
     下部の光る年表バーが各年ドットへ進み、到達と同時にシリーズカードが
     画面外(右)から登場(blue=カットイン/pink=振り子/premium=金の流れ星牽引)。
     エディタ/reduced-motion=静的クラスで完成形表示(初期隠しはJSインラインのみ)。
     gsap.matchMedia()で750px跨ぎを初期化/クリーンアップ。セクションルートに
     スコープ(ID非依存=複数配置・エディタ複製に安全) */
  document.querySelectorAll('.nx-history').forEach(function (histSec) {
    var histPin = histSec.querySelector('.nx-history__pin');
    if (!histPin) return;
    if (reduce || (window.Shopify && Shopify.designMode)) {
      histSec.classList.add('nx-history--static');
      return;
    }
    var hCards = gsap.utils.toArray(histSec.querySelectorAll('.nx-hcard'));
    if (!hCards.length) return;

    var histClamp = function (v) {
      return Math.min(1, Math.max(0, v));
    };
    var histSeg = function (p, a, b) {
      return histClamp((p - a) / (b - a));
    };
    var histLerp = function (a, b, t) {
      return a + (b - a) * t;
    };
    var outCubic = function (t) {
      return 1 - Math.pow(1 - t, 3);
    };
    var outBack = function (t) {
      var c1 = 1.70158,
        c3 = c1 + 1;
      return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
    };
    /* 登場バリアント(e:0→1 → 最終位置からのオフセット) */
    var HVAR = {
      slash: function (e) {
        var t = outBack(outCubic(e));
        return {
          x: (1 - t) * 95,
          y: 0,
          rot: (1 - e) * -3,
          scale: 1,
          blur: (1 - outCubic(e)) * 14,
          skew: (1 - outCubic(e)) * -10,
          op: histSeg(e, 0, 0.25),
        };
      },
      pendulum: function (e) {
        var t = outCubic(e);
        return {
          x: (1 - t) * 80,
          y: (1 - t) * -38,
          rot: 26 * Math.pow(1 - e, 1.4) * Math.cos(e * 9.4),
          scale: 1,
          blur: 0,
          skew: 0,
          op: histSeg(e, 0, 0.2),
        };
      },
      trail: function (e) {
        var t2 = histSeg(e, 0.45, 1);
        return {
          x: 0,
          y: histLerp(26, 0, outBack(t2)),
          rot: 0,
          scale: histLerp(0.6, 1, outBack(t2)),
          blur: 0,
          skew: 0,
          op: t2,
          trail: histSeg(e, 0, 0.75),
        };
      },
    };
    var HPAL = {
      blue: ['#EAF7FF', '#BFE6F5', '#8FD2F2', '#6FC2EE', '#3E8FD6'],
      pink: ['#FFF0F3', '#FFD9E0', '#F8AEBE', '#F08CA0', '#FFB39C'],
      premium: ['#FFF9EC', '#F7E8C9', '#EDD293', '#D4AF6A', '#C79A3C'],
    };
    var HVAR_BY_TINT = { blue: 'slash', pink: 'pendulum', premium: 'trail' };
    /* 不可視カードはリンクとして触れない(表示状態とインタラクションを同期) */
    var setCardActive = function (c, on) {
      if (c._nxOn === on) return;
      c._nxOn = on;
      c.style.pointerEvents = on ? '' : 'none';
      if (on) {
        c.removeAttribute('tabindex');
        c.removeAttribute('aria-hidden');
      } else {
        c.setAttribute('tabindex', '-1');
        c.setAttribute('aria-hidden', 'true');
      }
    };

    var histMM = gsap.matchMedia();

    /* ===== デスクトップ(>=750px): ピン留め+進行度レンダリング ===== */
    histMM.add('(min-width: 750px)', function () {
      var hFill = histSec.querySelector('.nx-history__fill');
      var hHead = histSec.querySelector('.nx-history__hd');
      var hPills = gsap.utils.toArray(histSec.querySelectorAll('.nx-history__pill'));
      var hTrailSvg = histSec.querySelector('.nx-history__trail');
      var hDots = gsap.utils.toArray(histSec.querySelectorAll('.nx-hdot'));
      var hXs = hCards.map(function (c) {
        return parseFloat(c.dataset.x) || 50;
      });
      /* 進行度の割付(3枚時はデモ実測値。枚数可変にも一般化) */
      var hEnters =
        hCards.length === 3
          ? [
              [0.1, 0.3],
              [0.4, 0.58],
              [0.66, 0.84],
            ]
          : hCards.map(function (c, i) {
              var s = 0.08 + (i * 0.76) / hCards.length;
              return [s, s + 0.18];
            });
      var hSegs = [];
      var hLit = [];
      var prevEnd = 0,
        prevX = -4;
      hCards.forEach(function (c, i) {
        var arrive = hEnters[i][0] + 0.02;
        hSegs.push([prevEnd, arrive, prevX, hXs[i]]);
        hLit.push(arrive);
        prevEnd = hEnters[i][1];
        prevX = hXs[i];
      });
      hSegs.push([prevEnd, 1, prevX, 112]); /* 最終年ドット(92%)を通過し112%=画面外へ抜ける */
      hLit.push(0.9); /* 最終年ドット */

      /* 流れ星トレイル(粒子帯のみ・芯線なし=キラキラと残像だけで軌跡を描く)。パス/長さはリサイズ時のみ再計算 */
      var NSVG = 'http://www.w3.org/2000/svg';
      var hSeed = 1000;
      var hRnd = function () {
        hSeed = (hSeed * 1664525 + 1013904223) >>> 0;
        return hSeed / 4294967296;
      };
      var hTrails = hCards.map(function (c) {
        var pal = HPAL[c.dataset.tint] || HPAL.premium;
        var parts = [];
        for (var k = 0; k < 74; k++) {
          parts.push({
            off: k / 74,
            perp: (hRnd() - 0.5) * 26,
            r: 0.9 + hRnd() * 2.2,
            color: pal[(hRnd() * pal.length) | 0],
            tw: 2 + hRnd() * 5,
            ph: hRnd() * 6.28,
            star: hRnd() < 0.16,
          });
        }
        return {
          parts: parts,
          pal: pal,
          g: null,
          path: null,
          core: null,
          nodes: null,
          head: null,
          bloom: null,
          W: 0,
          H: 0,
          len: 0,
        };
      });
      var hBuildTrail = function (i) {
        var tr = hTrails[i];
        tr.g = document.createElementNS(NSVG, 'g');
        tr.path = document.createElementNS(NSVG, 'path');
        tr.path.setAttribute('fill', 'none');
        tr.path.setAttribute('stroke', 'none');
        tr.g.appendChild(tr.path);
        tr.W = 0; /* 再生成のたびdを必ず再計算(サイズ不変の再進入で空pathにgetPointAtLength→例外の潜在バグ対策) */
        tr.H = 0;
        tr.nodes = tr.parts.map(function (pt) {
          var nd;
          if (pt.star) {
            nd = document.createElementNS(NSVG, 'path');
            nd.setAttribute('stroke-linecap', 'round');
            nd.setAttribute('fill', 'none');
            nd.setAttribute('stroke', pt.color);
            nd.setAttribute('stroke-width', 1.1);
          } else {
            nd = document.createElementNS(NSVG, 'circle');
            nd.setAttribute('r', pt.r);
            nd.setAttribute('fill', pt.color);
          }
          tr.g.appendChild(nd);
          return nd;
        });
        tr.bloom = document.createElementNS(NSVG, 'circle');
        tr.bloom.setAttribute('r', 11);
        tr.bloom.setAttribute('fill', tr.pal[3]);
        tr.bloom.style.filter = 'blur(6px)';
        tr.head = document.createElementNS(NSVG, 'circle');
        tr.head.setAttribute('r', 3.2);
        tr.head.setAttribute('fill', '#FFFDF6');
        tr.head.style.filter = 'drop-shadow(0 0 6px ' + tr.pal[3] + ')';
        tr.g.appendChild(tr.bloom);
        tr.g.appendChild(tr.head);
        hTrailSvg.appendChild(tr.g);
      };
      var hDrawTrail = function (i, prog, now) {
        var tr = hTrails[i];
        if (prog <= 0 || prog >= 1) {
          if (tr.g) {
            tr.g.remove();
            tr.g = null;
          }
          return;
        }
        if (!tr.g) hBuildTrail(i);
        var W = innerWidth,
          H = innerHeight;
        if (W !== tr.W || H !== tr.H) {
          /* パス形状はサイズ変化時のみ再計算(getTotalLengthのper-frameコスト回避) */
          tr.W = W;
          tr.H = H;
          hTrailSvg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
          var x1 = (hXs[i] / 100) * W,
            y1 = H * 0.92 - 62;
          var x2 = x1,
            y2 = H * 0.48;
          var cx = x1 + W * 0.11,
            cy = (y1 + y2) / 2 + H * 0.03;
          var d = 'M' + x1 + ',' + y1 + ' Q' + cx + ',' + cy + ' ' + x2 + ',' + y2;
          tr.path.setAttribute('d', d);
          tr.len = tr.path.getTotalLength();
        }
        var len = tr.len;
        var hh = outCubic(histClamp(prog / 0.72));
        var fade = 1 - Math.pow(histSeg(prog, 0.68, 1), 1.4);
        tr.parts.forEach(function (pt, k) {
          var nd = tr.nodes[k];
          var tp = hh - pt.off * 0.42;
          if (tp <= 0 || tp > 1) {
            nd.setAttribute('opacity', 0);
            return;
          }
          var pos = tr.path.getPointAtLength(tp * len);
          var ahead = tr.path.getPointAtLength(Math.min(tp * len + 2, len));
          var dx = ahead.x - pos.x,
            dy = ahead.y - pos.y,
            dl = Math.hypot(dx, dy) || 1;
          var px = -dy / dl,
            py = dx / dl;
          var spread = 0.18 + 0.95 * pt.off;
          var x = pos.x + px * pt.perp * spread,
            y = pos.y + py * pt.perp * spread;
          var tail = Math.pow(1 - pt.off, 0.8);
          var tw = 0.55 + 0.45 * Math.sin(now * pt.tw + pt.ph);
          nd.setAttribute('opacity', (fade * tail * tw).toFixed(3));
          if (pt.star) {
            var sz = pt.r * 2.2;
            nd.setAttribute(
              'd',
              'M' +
                (x - sz) +
                ',' +
                y +
                ' L' +
                (x + sz) +
                ',' +
                y +
                ' M' +
                x +
                ',' +
                (y - sz) +
                ' L' +
                x +
                ',' +
                (y + sz),
            );
            nd.setAttribute('transform', 'rotate(45 ' + x + ' ' + y + ')');
          } else {
            nd.setAttribute('cx', x);
            nd.setAttribute('cy', y);
          }
        });
        var hp = tr.path.getPointAtLength(hh * len);
        var headOp = fade * (hh < 1 ? 1 : 0);
        tr.head.setAttribute('cx', hp.x);
        tr.head.setAttribute('cy', hp.y);
        tr.head.setAttribute('opacity', headOp.toFixed(3));
        tr.bloom.setAttribute('cx', hp.x);
        tr.bloom.setAttribute('cy', hp.y);
        tr.bloom.setAttribute('opacity', (headOp * 0.4).toFixed(3));
      };

      /* 初期状態(隠す)はインラインのみ: エディタ再描画では素の可視に戻る */
      hCards.forEach(function (c) {
        c.style.opacity = 0;
        setCardActive(c, false);
      });

      var histP = 0;
      var histActive = false;
      var histLastP = -1;
      ScrollTrigger.create({
        trigger: histPin,
        start: 'top top',
        end: '+=150%',
        pin: true,
        scrub: true,
        onUpdate: function (self) {
          histP = self.progress;
        },
        onToggle: function (self) {
          histActive = self.isActive;
        },
      });
      var histTick = function (time) {
        if (!histActive && histP === histLastP) return;
        histLastP = histP;
        var p = histP,
          t = time;
        /* 年表バー */
        var hx = -4;
        hSegs.forEach(function (s) {
          if (p >= s[0]) hx = histLerp(s[2], s[3], outCubic(histSeg(p, s[0], s[1])));
        });
        hFill.style.width = histClamp(hx / 100) * 100 + '%';
        hHead.style.left = hx + '%';
        hHead.style.opacity = p > 0.004 && hx < 108 ? 1 : 0;
        hHead.style.transform = 'translate(-50%,-50%) scale(' + (1 + Math.sin(t * 6) * 0.18) + ')';
        hDots.forEach(function (d, i) {
          var lit = p >= hLit[Math.min(i, hLit.length - 1)];
          d.classList.toggle('lit', lit);
          d.style.transform =
            'translate(-50%,-50%) translateY(' + (lit ? Math.sin(t * 2.2 + i * 1.7) * 3.2 : 0) + 'px)';
        });
        /* 機能性表示食品ピル: ドットから発生→ゆっくり上昇→バーの少し上へ */
        hPills.forEach(function (pl) {
          var pv = outCubic(histSeg(p, 0.74, 0.92));
          pl.style.opacity = (pv * 0.95).toFixed(3);
          pl.style.top = histLerp(59, 22, pv) + 'px';
          pl.style.transform = 'translate(-50%,-50%) translateY(' + Math.sin(t * 2) * 2.2 + 'px)';
        });
        /* カード */
        hCards.forEach(function (c, i) {
          var vName = HVAR_BY_TINT[c.dataset.tint] || ['slash', 'pendulum', 'trail'][i % 3];
          var es = hEnters[i][0],
            ee = hEnters[i][1];
          if (p < es) {
            c.style.opacity = 0;
            setCardActive(c, false);
            hDrawTrail(i, 0, t);
            return;
          }
          var e = histSeg(p, es, ee);
          var o = HVAR[vName](e);
          hDrawTrail(i, vName === 'trail' && e < 1 ? o.trail : 0, t);
          var nextEs = i < hCards.length - 1 ? hEnters[i + 1][0] : 0.9;
          var f = 1 - outCubic(histSeg(p, nextEs, nextEs + 0.08));
          var baseScale = histLerp(0.84, 1.06, f);
          var idle = e >= 1 ? Math.sin(t * 1.6 + i * 2.1) * 5 : 0;
          var op = o.op * histLerp(0.85, 1, f);
          c.style.opacity = op.toFixed(3);
          setCardActive(c, op > 0.5);
          c.style.filter = o.blur > 0.4 ? 'blur(' + o.blur.toFixed(1) + 'px)' : '';
          c.style.transform =
            'translate(-50%,-50%) translate(' +
            o.x +
            'vw,' +
            o.y +
            'vh) translateY(' +
            idle +
            'px) rotate(' +
            o.rot.toFixed(2) +
            'deg) skewX(' +
            (o.skew || 0).toFixed(2) +
            'deg) scale(' +
            (baseScale * o.scale).toFixed(3) +
            ')';
        });
      };
      gsap.ticker.add(histTick);

      /* クリーンアップ(<750pxへ切替時): ScrollTrigger/pinはmatchMediaが自動revert */
      return function () {
        gsap.ticker.remove(histTick);
        hCards.forEach(function (c) {
          c.style.opacity = '';
          c.style.transform = '';
          c.style.filter = '';
          setCardActive(c, true);
        });
        hTrails.forEach(function (tr) {
          if (tr.g) {
            tr.g.remove();
            tr.g = null;
          }
        });
        hDots.forEach(function (d) {
          d.classList.remove('lit');
          d.style.transform = '';
        });
        hFill.style.width = '';
        hHead.style.opacity = 0;
        hPills.forEach(function (pl) {
          pl.style.opacity = '';
          pl.style.top = '';
          pl.style.transform = '';
        });
      };
    });

    /* ===== モバイル(<750px): 縦積み+左の光ライン(ピンなし) =====
       光の先端は常に画面の「下から約1/3(=上から68%)」を進む(vh非依存)。
       各カードの年号ドットがこのフロント線に達した瞬間に点灯=光の先端とドットが一致 */
    histMM.add('(max-width: 749px)', function () {
      var hStage = histPin.querySelector('.nx-history__stage');
      var FRONT = 0.68; /* 光の先端の画面内位置(上から68%=下から約1/3) */
      var remPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 10;
      var hYears = hCards.map(function (c) {
        return c.querySelector('.nx-hcard__year') || c;
      });
      /* ::after は top:16rem 起点・track下端(bottom:6rem)まで=max-height calc(100%-22rem)。
         フロント線(FRONT*vh)が stage 内のどこに来るかから充填量を逆算=先端が常に画面68%を通過。
         ドット点灯も同じ live front で判定=先端と基準を一元化(実機のツールバー伸縮でもdesyncしない) */
      var setFill = function () {
        var front = FRONT * innerHeight; /* フロント線の画面Y(下から約1/3) */
        /* rectは全て先に読む(read)→styleとclassは後でまとめて書く(write): レイアウトスラッシュ回避 */
        var sr = hStage.getBoundingClientRect();
        var dotY = hYears.map(function (y) {
          var r = y.getBoundingClientRect();
          return r.top + r.height / 2; /* 年号ドット中心(::before top:50%) */
        });
        var lineMax = sr.height - 22 * remPx;
        var fillPx = Math.max(0, Math.min(front - sr.top - 16 * remPx, lineMax));
        hStage.style.setProperty('--nx-vfill', fillPx.toFixed(1) + 'px');
        hCards.forEach(function (c, i) {
          c.classList.toggle('nx-hin', dotY[i] <= front); /* ドット中心が先端(front)に到達 */
        });
      };
      ScrollTrigger.create({
        trigger: hStage,
        start: 'top bottom',
        end: 'bottom top',
        onUpdate: setFill,
        onRefresh: setFill,
        /* 省電力(画面外では回さない): 星のCSSアニメを在圏中だけrunningにする。
           onToggleは出入りの2回だけ発火=per-frameコストなし */
        onToggle: function (self) {
          hStage.classList.toggle('nx-hs-on', self.isActive);
        },
      });
      setFill();
      hCards.forEach(function (c) {
        var tint = c.dataset.tint;
        var fromVars =
          tint === 'pink'
            ? { x: 60, y: -30, rotation: 12, opacity: 0 }
            : tint === 'premium'
              ? { y: 40, scale: 0.82, opacity: 0 }
              : { x: 90, skewX: -8, opacity: 0 };
        setCardActive(c, false);
        gsap.fromTo(c, fromVars, {
          x: 0,
          y: 0,
          rotation: 0,
          skewX: 0,
          scale: 1,
          opacity: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: c,
            start: 'top 88%',
            end: 'top 60%',
            scrub: 0.5,
            onUpdate: function (self) {
              setCardActive(c, self.progress > 0.5);
            },
          },
        });
        /* 年号ドット点灯は setFill 内で先端と同じ live front から判定(基準一元化) */
      });
      /* クリーンアップ(>=750pxへ切替時): tween/ScrollTriggerはmatchMediaが自動revert */
      return function () {
        hCards.forEach(function (c) {
          c.classList.remove('nx-hin');
          setCardActive(c, true);
        });
        hStage.style.removeProperty('--nx-vfill');
        hStage.classList.remove('nx-hs-on');
      };
    });
  });
  /* エディタ: セクション再描画で静的クラスを付け直す(designModeのみ) */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (ev) {
      var hs = ev.target.querySelector('.nx-history');
      if (hs) hs.classList.add('nx-history--static');
    });
  }

  /* ---- ドラッグストリップ汎用(慣性+速度スキュー=voldog式ぬるっと) ---- */
  document.querySelectorAll('.nx-dragstrip').forEach(function (strip) {
    if (!reduce) {
      var skew = gsap.quickTo(strip, 'skewX', { duration: 0.45, ease: 'power3' });
      var lastL = strip.scrollLeft,
        settle;
      strip.addEventListener(
        'scroll',
        function () {
          var v = strip.scrollLeft - lastL;
          lastL = strip.scrollLeft;
          skew(gsap.utils.clamp(-4, 4, -v * 0.25));
          clearTimeout(settle);
          settle = setTimeout(function () {
            skew(0);
          }, 90);
        },
        { passive: true },
      );
    }
    /* ⚠️2026-08-08: pointer:fine ゲートを撤去し、タッチでも横ドラッグできるようにした。
       CSS で .nx-voice__strip に touch-action:pan-y を入れてブラウザの横パンを禁止した
       (=斜めフリックでも縦は必ずページへ抜ける)ため、横めくりはこのハンドラが肩代わりする。
       CSSの touch-action とこの実装は必ずセットで維持すること。
       「捕捉はドラッグ成立後」の形は nx-lineup-v2.js:301-354 と同型(2026-07-25にPlaywright実測で確立) */
    var down = false,
      drag = false,
      vscroll = false,
      pid = null,
      sx = 0,
      sy = 0,
      sl = 0,
      vx = 0,
      vy = 0,
      moved = 0,
      lastX = 0,
      lastY = 0,
      lastT = 0,
      fling = null;
    strip.addEventListener('pointerdown', function (e) {
      /* 2本目以降の指は無視。拾うと sx/sl が上書きされ、指間距離ぶん瞬間ジャンプする。
         ⚠️`down` を条件に足してはいけない。捕捉前(8pxスロップ確定前)に指がストリップ外で離れると
         pointerup がこの要素に届かず down が真のまま残るため、以後の全 pointerdown を弾いて
         ドラッグがリロードまで復帰しなくなる。無条件に初期化することが自己修復になっている */
      if (e.isPrimary === false) return;
      down = true;
      drag = false;
      vscroll = false;
      pid = e.pointerId;
      moved = 0;
      sx = e.clientX;
      sy = e.clientY;
      sl = strip.scrollLeft;
      vx = 0;
      vy = 0;
      lastX = e.clientX;
      lastY = e.clientY;
      lastT = performance.now();
      /* 慣性の残りは掴んだ瞬間に止める(掴んでも滑り続けると制御を奪われた感覚になる) */
      if (fling) {
        fling.kill();
        fling = null;
      }
      /* ⚠️ここで setPointerCapture してはいけない。捕捉すると click が捕捉要素へ再ターゲットされ、
         バブル内の口コミCTAアンカーの遷移が起きなくなる(nx-lineup-v2.js:308-313 に実測記録)。
         捕捉は横ドラッグが成立してから pointermove 側で行う */
    });
    strip.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      if (vscroll) {
        /* 縦フォールバック(2026-08-10): ここへ来る=ブラウザは既にこのジェスチャを「横」と分類して
           縦パンを放棄している(縦を取っていれば pointercancel が来てこのストリームは途絶えている)。
           指の縦成分をJSでページに渡す。Android実機の「まっすぐ縦のつもりでも進まない」の正体は
           出だし数pxの斜れによる横分類で、この補完がその死角を埋める */
        var mdy = e.clientY - lastY;
        moved += Math.abs(mdy);
        window.scrollBy(0, -mdy);
        var vnow = performance.now();
        /* ⚠️±4px/msにクランプ必須。イベントが同一フレームに密集すると dt≈0 で速度が発散し、
           離した瞬間に数千px吹き飛ぶ(実測)。4px/ms×320=最大1280pxはネイティブの強フリック相当 */
        vy = gsap.utils.clamp(-4, 4, mdy / Math.max(vnow - lastT, 8));
        lastY = e.clientY;
        lastT = vnow;
        return;
      }
      if (!drag) {
        var ax = Math.abs(e.clientX - sx),
          ay = Math.abs(e.clientY - sy);
        /* 8pxのスロップまでは判定保留 */
        if (ax < 8 && ay < 8) return;
        /* 軸ロックはタッチ/ペンだけ。マウスにはページを譲る相手(ネイティブ縦パン)が無く、
           斜めドラッグで横に送れなくなるだけの劣化になるため従来どおり横へ流す */
        if (ax <= ay && e.pointerType !== 'mouse') {
          /* ⚠️すぐJSで縦を始めてはいけない。ブラウザ自身の縦パン判定(スロップ約10px)と競合して
             二重スクロールになる。16pxまで待って、なお pointermove が届き続けている
             (=ブラウザが縦を取らなかった)場合だけJSが引き受ける */
          if (ay < 16) return;
          vscroll = true;
          /* 捕捉する: 縦補完中は指がすぐ帯の外へ出るため、捕捉しないと pointermove が
             ストリップに届かなくなり途中で止まる。ジェスチャ確定後なのでCTAクリックは壊さない */
          try {
            strip.setPointerCapture(pid);
          } catch (verr) {}
          lastY = e.clientY;
          lastT = performance.now();
          return;
        }
        drag = true;
        try {
          strip.setPointerCapture(pid);
        } catch (err) {}
        /* 捕捉を8pxスロップの裏へ回した副作用で、その間にブラウザがテキスト選択を始めている。
           選択を消す(user-select:noneは口コミ本文をコピーできなくするので使わない) */
        try {
          var sel = getSelection();
          if (sel) sel.removeAllRanges();
        } catch (err2) {}
        /* 成立フレームで基準を取り直し、スロップ分の飛びを消す */
        sx = e.clientX;
        sl = strip.scrollLeft;
        lastX = e.clientX;
        lastT = performance.now();
        return;
      }
      moved += Math.abs(e.clientX - lastX);
      strip.scrollLeft = sl - (e.clientX - sx);
      var now = performance.now();
      vx = (e.clientX - lastX) / Math.max(now - lastT, 1);
      lastX = e.clientX;
      lastT = now;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      strip.addEventListener(ev, function (e) {
        if (!down || (e && e.pointerId !== pid)) return;
        down = false;
        pid = null;
        if (vscroll) {
          vscroll = false;
          /* cancel時は慣性を出さない(ブラウザ側に主導権が移った可能性があるため) */
          if (e && e.type === 'pointercancel') return;
          /* 指が静止してから離した場合は慣性ゼロ(ネイティブと同じ)。vyは最後の移動時の値が
             残っているため、これが無いと「止めてから離す」で幻の慣性が出る */
          if (performance.now() - lastT > 90) vy = 0;
          /* 動きの抑制設定ではスクリプト駆動の0.9秒スクロールを出さない */
          if (reduce || !vy) return;
          /* 縦補完の慣性: ネイティブスクロールの余韻に寄せる。対象はページなので
             ダミーオブジェクトを介して window スクロールへ書く */
          var vgoal = { y: window.scrollY };
          fling = gsap.to(vgoal, {
            y: window.scrollY - vy * 320,
            duration: 0.9,
            ease: 'power3.out',
            onUpdate: function () {
              window.scrollTo(0, vgoal.y);
            },
          });
          /* ⚠️ページ縦慣性はグローバル資源。fling参照はストリップ毎のクロージャに閉じるため、
             隣のvoice行や帯外への次タッチでは殺せず、scrollToの毎フレーム絶対値書きが新しい指と
             最大0.9秒喧嘩する。どこへのpointerdownでも即kill(ネイティブの「触れたら慣性停止」と同義)。
             captureはstripハンドラより先に走り、onceは最初のpointerdownで必ず消費されるので、
             後続tweenの誤killは構造上起きない(新flingは必ず新しいpointerdownを経てしか生まれない) */
          var vkill = function () {
            if (fling) {
              fling.kill();
              fling = null;
            }
          };
          window.addEventListener('pointerdown', vkill, { capture: true, once: true });
          return;
        }
        /* 縦フリック由来のcancelでは慣性を出さない(横に暴れて見える) */
        if (!drag) return;
        drag = false;
        fling = gsap.to(strip, { scrollLeft: strip.scrollLeft - vx * 320, duration: 0.9, ease: 'power3.out' });
      });
    });
    strip.addEventListener(
      'click',
      function (e) {
        /* 速度ではなく移動距離で判定する。ゆっくり大きく送った指は速度が乗らず
           従来の |vx|>0.2 をすり抜けてリンクを踏んでしまっていた */
        /* e.detail===0 はキーボード(Enter/Space)由来の合成click。指のドラッグ後に
           clickが発火しないまま Tab→Enter された場合でもレビューCTAを潰さない */
        if (e.detail !== 0 && moved > 8) e.preventDefault();
        /* 判定に使ったら必ず捨てる */
        moved = 0;
      },
      true,
    );
  });

  /* ---- customer's voice: バブル出現+★が順番に点灯 ---- */
  /* ⚠️2026-08-24 T-3a: この2本の gsap.from() が初期ロードの同期パス607ms中265ms(44%)だった。
     nxLazy で「セクションが近づいてから」生成に変更(LoAF実測 790→440ms / 強制レイアウト 493→250ms)。
     🔑対象要素はここ(=マーキーのcloneNodeより前)で確定させ、配列で渡す。
       セレクタ文字列のまま遅延させると、後段(行1250付近)の .nx-vrow 複製で増えたクローン側にも
       from が掛かり演出が変わる(実測: 従来はオリジナル17個のみ非表示→登場、クローン17個は最初から可視)。
       querySelectorAll 自体は1ms未満で、重いのは gsap の算出スタイル読み取りの方。
     🔑root(.nx-voice)と strip の両方を必須にし、trigger も要素参照で渡す。
       ガードが食い違うと「隠したまま出せない」事故になるため(Codexレビュー#T3a HIGH)。 */
  var voiceSec = document.querySelector('.nx-voice');
  if (voiceSec && voiceSec.querySelector('.nx-voice__strip')) {
    var vBubbleEls = Array.prototype.slice.call(voiceSec.querySelectorAll('.nx-vbubble'));
    var vStarEls = Array.prototype.slice.call(voiceSec.querySelectorAll('.nx-star'));
    nxLazy(voiceSec, function () {
      if (!voiceSec.isConnected || (!vBubbleEls.length && !vStarEls.length)) return;
      gsap.from(vBubbleEls, {
        y: 44,
        opacity: 0,
        rotate: 3,
        stagger: 0.07,
        duration: 0.65,
        ease: 'back.out(1.4)',
        clearProps: 'transform,opacity',
        scrollTrigger: { trigger: voiceSec, start: 'top 78%' },
      });
      gsap.from(vStarEls, {
        scale: 0,
        opacity: 0,
        stagger: 0.04,
        duration: 0.4,
        ease: 'back.out(2.2)',
        clearProps: 'transform,opacity',
        scrollTrigger: { trigger: voiceSec, start: 'top 72%' },
      });
    });
  }

  /* ---- values: カード出現 → 本文が一段"浮き上がる"二重フェード(2026-07-21) ----
     1波目=カード(画像込み)がじんわり上昇、2波目=各カードの__body(見出し+本文)が
     わずかに遅れて浮き上がる。単一ScrollTriggerのタイムラインで2波を連結。
     reduced-motionは演出なし(基底CSSに非表示指定が無いので即可視=no-JSと同じ)。 */
  /* エディタ(designMode)/reduced-motionは演出なし=基底CSSに非表示指定が無いので即可視
     (エディタでScrollTrigger未発火→透明固定になる罠をガード。.nx-subsc__perkと同方針)。
     対象はvGrid内にスコープ(複数配置/複製でも他gridを巻き込まない=codex#59対応で全gridをforEach)。
     カードはclearProps付けない=data-nx-tiltのrotationX/Y管理をGSAPに残す(tilt継続) */
  if (!reduce && !(window.Shopify && Shopify.designMode)) {
    Array.prototype.forEach.call(document.querySelectorAll('.nx-values__grid'), function (vGrid) {
      var vTl = gsap.timeline({ scrollTrigger: { trigger: vGrid, start: 'top 80%' } });
      vTl.from(vGrid.querySelectorAll('.nx-vcard'), {
        y: 50,
        opacity: 0,
        stagger: 0.12,
        duration: 0.75,
        ease: 'power3.out',
      });
      vTl.from(
        vGrid.querySelectorAll('.nx-vcard__body'),
        {
          y: 22,
          opacity: 0,
          stagger: 0.12,
          duration: 0.7,
          ease: 'power3.out',
          clearProps: 'opacity,transform',
        },
        '-=0.25',
      );
    });
  }
  if (fine && !reduce) {
    document.querySelectorAll('[data-nx-tilt]').forEach(function (card) {
      var rx = gsap.quickTo(card, 'rotationX', { duration: 0.5, ease: 'power3' });
      var ry = gsap.quickTo(card, 'rotationY', { duration: 0.5, ease: 'power3' });
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        ry(((e.clientX - r.left) / r.width - 0.5) * 8);
        rx(-((e.clientY - r.top) / r.height - 0.5) * 8);
      });
      card.addEventListener('pointerleave', function () {
        rx(0);
        ry(0);
      });
    });
  }

  /* ---- ribbon: テキスト滑走+周年カウントアップ ---- */
  var ribbonText = document.getElementById('nxRibbonText');
  if (ribbonText) {
    gsap.to(ribbonText, {
      attr: { startOffset: '14%' },
      ease: 'none',
      scrollTrigger: { trigger: '.nx-ribbon', start: 'top bottom', end: 'bottom top', scrub: 0.8 },
    });
  }
  var countEl = document.getElementById('nxAnnivCount');
  if (countEl) {
    var target = parseInt(countEl.dataset.target || '12', 10);
    var countObj = { v: 0 };
    gsap.to(countObj, {
      v: target,
      ease: 'none',
      scrollTrigger: { trigger: '.nx-ribbon', start: 'top 88%', end: 'center 55%', scrub: true },
      onUpdate: function () {
        countEl.textContent = Math.round(countObj.v);
      },
    });
    gsap.from('.nx-ribbon__inner', {
      scale: 0.85,
      opacity: 0,
      duration: 0.8,
      ease: 'back.out(1.4)',
      scrollTrigger: { trigger: '.nx-ribbon', start: 'top 78%' },
    });
  }

  /* ---- how to use: ライン描画+ステップ点灯 ---- */
  var howtoGrid = document.getElementById('nxHowtoGrid');
  if (howtoGrid) {
    var hsteps = gsap.utils.toArray('.nx-hstep');
    var hobj = { p: 0 };
    gsap.to(hobj, {
      p: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: howtoGrid,
        start: 'top 72%',
        end: 'bottom 52%',
        scrub: 0.5,
        onUpdate: function () {
          howtoGrid.style.setProperty('--hp', hobj.p.toFixed(4));
          hsteps.forEach(function (s, i) {
            s.classList.toggle('on', hobj.p >= (i + 0.35) / hsteps.length);
          });
        },
      },
    });
  }

  /* ---- subscription: 旧チップ入場(.nx-subsc__chips)は2026-07-13の
     ベネフィットカード刷新で廃止。新ポップインはファイル末尾(ScrollTrigger.sort前)へ ---- */

  /* ---- faq: ぬるっとアコーディオン ---- */
  document.querySelectorAll('.nx-fitem').forEach(function (item) {
    var q = item.querySelector('.nx-fitem__q');
    var a = item.querySelector('.nx-fitem__a');
    if (!q || !a) return;
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function () {
      var open = item.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      gsap.to(a, {
        height: open ? 'auto' : 0,
        duration: 0.55,
        ease: 'power3.inOut',
        onComplete: function () {
          ScrollTrigger.refresh();
        },
      });
    });
  });
  if (document.querySelector('.nx-faq__list')) {
    gsap.from('.nx-fitem', {
      y: 30,
      opacity: 0,
      stagger: 0.07,
      duration: 0.6,
      ease: 'power3.out',
      scrollTrigger: { trigger: '.nx-faq__list', start: 'top 84%' },
    });
  }

  /* ---- journal: カード出現(hover浮上はCSSなのでinline transformを残さない) ---- */
  if (document.querySelector('.nx-news__grid')) {
    gsap.from('.nx-ncard', {
      y: 48,
      opacity: 0,
      rotate: 1.2,
      stagger: 0.1,
      duration: 0.7,
      ease: 'power3.out',
      clearProps: 'transform',
      scrollTrigger: { trigger: '.nx-news__grid', start: 'top 80%' },
    });
  }

  /* ---- news list / shops / sns: 出現(hover系はCSS=inline transformを残さない) ---- */
  if (document.querySelector('.nx-nrows')) {
    gsap.from('.nx-nrow', {
      y: 24,
      opacity: 0,
      stagger: 0.06,
      duration: 0.55,
      ease: 'power3.out',
      clearProps: 'transform',
      scrollTrigger: { trigger: '.nx-nrows', start: 'top 84%' },
    });
    /* モバイルのサムネイル・マスクリビール(2026-08-26): 行ごとにビュー進入で .nx-in を一度だけ付与。
       露出後は即unobserve=居残りコストゼロ(省電力方針)。見た目はCSS側が担当(PCではサムネ非表示=無害) */
    var nThumbRows = document.querySelectorAll('.nx-nrow--img');
    if (nThumbRows.length && !('IntersectionObserver' in window)) {
      /* IO不在の旧ブラウザ: カーテンを即時全開(nxLazyのIOフォールバックと同方針) */
      nThumbRows.forEach(function (r) {
        r.classList.add('nx-in');
      });
    }
    if (nThumbRows.length && 'IntersectionObserver' in window) {
      var nThumbIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('nx-in');
              nThumbIo.unobserve(en.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px' },
      );
      nThumbRows.forEach(function (r) {
        nThumbIo.observe(r);
      });
    }
  }
  if (document.querySelector('.nx-shops__grid')) {
    gsap.from('.nx-shopc', {
      y: 32,
      opacity: 0,
      stagger: 0.08,
      duration: 0.6,
      ease: 'power3.out',
      clearProps: 'transform',
      scrollTrigger: { trigger: '.nx-shops__grid', start: 'top 82%' },
    });
  }
  if (document.querySelector('.nx-sns__row')) {
    gsap.from('.nx-sns__a', {
      y: 30,
      opacity: 0,
      stagger: 0.07,
      duration: 0.55,
      ease: 'back.out(1.6)',
      clearProps: 'transform',
      scrollTrigger: { trigger: '.nx-sns__row', start: 'top 84%' },
    });
  }

  /* ---- 汎用折りたたみ(FAQカテゴリ/エリアアコーディオン) ---- */
  var bindFold = function (rootSel, headSel, bodySel) {
    document.querySelectorAll(rootSel).forEach(function (box) {
      var head = box.querySelector(headSel);
      var body = box.querySelector(bodySel);
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = box.classList.toggle('open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        gsap.to(body, {
          height: open ? 'auto' : 0,
          duration: 0.6,
          ease: 'power3.inOut',
          onComplete: function () {
            ScrollTrigger.refresh();
          },
        });
      });
    });
  };
  bindFold('.nx-fcat', '.nx-fcat__head', '.nx-fcat__body');
  bindFold('.nx-sgroup', '.nx-sgroup__head', '.nx-sgroup__body');
  if (document.querySelector('.nx-fcat')) {
    gsap.from('.nx-fcat', {
      y: 26,
      opacity: 0,
      stagger: 0.08,
      duration: 0.55,
      ease: 'power3.out',
      clearProps: 'transform,opacity',
      scrollTrigger: { trigger: '.nx-faq__wrap', start: 'top 84%' },
    });
  }

  /* ---- voice: 2列無限マーキー(上段=左→右/下段=右→左・列単位でホバー停止・ドラッグ両立) ----
     テーマエディタ(designMode)ではクローン/自動スクロールを行わず、ライブ同等の
     2段横並び(静止)のまま編集する。ブロック選択時はエディタの水平スクロール追従に
     依存せず、shopify:block:select で自前スクロールして選択カードを必ず可視化する */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.closest && e.target.closest('.nx-vrow')) {
        e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    });
  }
  /* ---- customer's voice マーキー ----
     ⚠️①GSAPのtickerでは駆動しない(2026-07-27 実測)。gsap.config().autoSleep=120 により
       アクティブなtweenが尽きると ticker ごと眠り、gsap.ticker.add() のリスナーでは
       それを防げない。実測で globalTimeline の children=136 なのに tick数=0 だった。
       = マーキーは「他のアニメが偶然動いている間だけ流れる」状態だった。
       → 専用の requestAnimationFrame ループへ移し、GSAPのライフサイクル依存を断つ。
     ⚠️②2段を「1つの停止状態」で束ねる。以前は段ごとに pause していたため、
       片方を読もうとしても もう片方が流れ続けて視線が持っていかれ、結局読めなかった。 */
  var vWrap = document.querySelector('.nx-strip-wrap');
  var vRows = Array.prototype.slice.call(document.querySelectorAll('.nx-vrow'));
  if (vWrap && vRows.length && !reduce && !(window.Shopify && Shopify.designMode)) {
    var vLanes = vRows.map(function (row, ri) {
      Array.prototype.slice.call(row.children).forEach(function (b) {
        var c = b.cloneNode(true);
        /* ⚠️ 複製元の inline style を必ず捨てる。
           gsap.from('.nx-vbubble', {opacity:0,...}) は ScrollTrigger 付きでも
           immediateRender が既定 true のため tween 構築時点で原本へ inline の
           opacity:0/transform を書き込む。clearProps は原本にしか効かないので、
           後から作るクローンは opacity:0 を写したまま永久に不可視になる。
           削除対象はクローンのルートのみ。子の <a style="margin-top:0"> は保持される。 */
        c.removeAttribute('style');
        c.setAttribute('aria-hidden', 'true');
        c.classList.add('nx-vclone');
        c.querySelectorAll('a,button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        row.appendChild(c);
      });
      /* 22px/s は読みに入る前に流れ去る速さだった。17px/s へ落とし、さらに
         下段へ7%の速度差を与えて2段が同じ周期で揃わないようにする
         (揃うと目がループを検知して一気に安っぽく見える) */
      var lane = {
        row: row,
        dir: parseFloat(row.dataset.dir || '1'),
        base: 0.017 * (ri === 0 ? 1 : 0.93),
        phase: ri * 2.1,
        half: 0,
        pos: null,
      };
      lane.measure = function () {
        lane.half = row.scrollWidth / 2;
        if (lane.dir < 0 && row.scrollLeft <= 1) row.scrollLeft = lane.half;
      };
      lane.measure();
      window.addEventListener('load', lane.measure);
      window.addEventListener('resize', lane.measure);
      return lane;
    });

    /* 速度倍率 0=停止/1=巡航。binaryで止めると機械的に見えるので、
       止まりは速く(τ150ms)・戻りは遅く(τ420ms)の非対称追従で「粘り」を出す */
    var vTarget = 1,
      vCur = 1,
      vResumeT,
      vVisible = true;
    var vPause = function () {
      clearTimeout(vResumeT);
      vTarget = 0;
    };
    var vResume = function () {
      clearTimeout(vResumeT);
      vResumeT = setTimeout(function () {
        vTarget = 1;
      }, 700);
    };
    vWrap.addEventListener('pointerenter', vPause);
    vWrap.addEventListener('pointerleave', vResume);
    vWrap.addEventListener('pointerdown', vPause);
    vWrap.addEventListener('pointerup', vResume);
    vWrap.addEventListener('touchstart', vPause, { passive: true });
    vWrap.addEventListener('touchend', vResume);
    vWrap.addEventListener('focusin', vPause);
    vWrap.addEventListener('focusout', vResume);

    /* 画面外では回さない(モバイルの電池と発熱。主要トラフィックがモバイルのため重要) */
    if (window.IntersectionObserver) {
      new IntersectionObserver(
        function (es) {
          vVisible = es[0].isIntersecting;
        },
        { rootMargin: '200px 0px' },
      ).observe(vWrap);
    }

    var vLast = 0,
      vClock = 0;
    var vTick = function (now) {
      requestAnimationFrame(vTick);
      /* タブ復帰等の巨大dtは丸める(一気に何周も進むのを防ぐ) */
      var dt = vLast ? Math.min(now - vLast, 100) : 16.7;
      vLast = now;
      if (!vVisible) return;
      var tau = vTarget < vCur ? 150 : 420;
      vCur += (vTarget - vCur) * (1 - Math.exp(-dt / tau));
      if (vCur < 0.0005) return;
      vClock += dt;
      for (var i = 0; i < vLanes.length; i++) {
        var L = vLanes[i];
        if (!L.half) continue;
        /* ⚠️scrollLeftを毎tick読み戻すと、1frame分(約0.37px)がChromeの物理px丸めで
           毎回切り捨てられ「全く流れない」(dpr=1環境で実測)。小数位置はJS側で蓄積し、
           ユーザーのドラッグ/手動スクロール(差分>2px)時のみ実値へ再同期する */
        if (L.pos === null || Math.abs(L.row.scrollLeft - L.pos) > 2) L.pos = L.row.scrollLeft;
        /* ごく緩い呼吸(±5%/約11秒・段ごとに位相をずらす)。
           完全な等速は「機械」に見えるが、これ以上大きいと今度は揺れとして知覚される */
        var breath = 1 + 0.05 * Math.sin((vClock / 11000) * 6.2831853 + L.phase);
        L.pos += L.dir * dt * L.base * vCur * breath;
        L.pos = ((L.pos % L.half) + L.half) % L.half;
        L.row.scrollLeft = L.pos;
      }
    };
    requestAnimationFrame(vTick);
  }

  /* ---- shops: カウントアップ+ブランドフィルタ+検索+自動開閉 ---- */
  var shopsSec = document.getElementById('nxShops');
  if (shopsSec) {
    var allChips = gsap.utils.toArray(shopsSec.querySelectorAll('.nx-schip'));
    var shopCountEl = document.getElementById('nxShopCount');
    var sco = { v: 0 };
    var setCount = function (n, slow) {
      gsap.to(sco, {
        v: n,
        duration: slow ? 1.6 : 0.6,
        ease: 'power2.out',
        overwrite: true,
        onUpdate: function () {
          if (shopCountEl) shopCountEl.textContent = Math.round(sco.v);
        },
      });
    };
    if (shopCountEl && allChips.length) {
      ScrollTrigger.create({
        trigger: '.nx-shops__bar',
        start: 'top 84%',
        once: true,
        onEnter: function () {
          setCount(allChips.length, true);
        },
      });
    }
    gsap.from('.nx-sgroup', {
      y: 26,
      opacity: 0,
      stagger: 0.07,
      duration: 0.55,
      ease: 'power3.out',
      clearProps: 'transform,opacity',
      scrollTrigger: { trigger: '#nxShopGroups', start: 'top 86%' },
    });

    var sgroups = gsap.utils.toArray('.nx-sgroup');
    var bpills = gsap.utils.toArray('.nx-bpill');
    var shopEmpty = document.getElementById('nxShopEmpty');
    var shopSearch = document.getElementById('nxShopSearch');
    var currentBrand = 'all';
    var setGroupOpen = function (g, open) {
      var head = g.querySelector('.nx-sgroup__head');
      var body = g.querySelector('.nx-sgroup__body');
      if (g.classList.contains('open') === open) return;
      g.classList.toggle('open', open);
      if (head) head.setAttribute('aria-expanded', open ? 'true' : 'false');
      gsap.to(body, { height: open ? 'auto' : 0, duration: 0.5, ease: 'power3.inOut' });
    };
    var applyShopFilter = function () {
      var q = ((shopSearch && shopSearch.value) || '').trim().toLowerCase();
      var filtering = q !== '' || currentBrand !== 'all';
      var visTotal = 0;
      sgroups.forEach(function (g) {
        var vis = 0;
        g.querySelectorAll('.nx-schip').forEach(function (c) {
          var hit =
            (currentBrand === 'all' || c.dataset.brand === currentBrand) &&
            (!q || c.textContent.toLowerCase().indexOf(q) > -1);
          c.style.display = hit ? '' : 'none';
          if (hit) vis++;
        });
        var badge = g.querySelector('.nx-sgroup__count');
        if (badge) badge.textContent = filtering ? vis : badge.dataset.total || vis;
        g.style.display = vis ? '' : 'none';
        setGroupOpen(g, filtering && vis > 0);
        visTotal += vis;
      });
      if (shopEmpty) shopEmpty.hidden = visTotal > 0;
      setCount(filtering ? visTotal : allChips.length, false);
      ScrollTrigger.refresh();
    };
    bpills.forEach(function (p) {
      p.addEventListener('click', function () {
        currentBrand = p.dataset.brand;
        bpills.forEach(function (o) {
          var on = o === p;
          o.classList.toggle('on', on);
          o.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyShopFilter();
      });
    });
    if (shopSearch) {
      var sdeb;
      shopSearch.addEventListener('input', function () {
        clearTimeout(sdeb);
        sdeb = setTimeout(applyShopFilter, 140);
      });
    }
  }

  /* ---- NEWS: hoverで記事プレビューがじわっと浮かびカーソルに追従 ---- */
  var npop = document.getElementById('nxNpop');
  if (npop && fine && !reduce) {
    var npopImg = npop.querySelector('img');
    var npopTxt = npop.querySelector('.nx-npop__txt');
    var npx = gsap.quickTo(npop, 'x', { duration: 0.38, ease: 'power3' });
    var npy = gsap.quickTo(npop, 'y', { duration: 0.38, ease: 'power3' });
    gsap.set(npop, { autoAlpha: 0, scale: 0.94, filter: 'blur(7px)' });
    document.querySelectorAll('#nxNrows .nx-nrow').forEach(function (row) {
      row.addEventListener('pointerenter', function () {
        var img = row.dataset.popImg || '';
        npop.classList.toggle('nx-npop--noimg', !img);
        if (img && npopImg.getAttribute('src') !== img) npopImg.src = img;
        npopTxt.textContent = row.dataset.popTxt || '';
        gsap.to(npop, { autoAlpha: 1, scale: 1, filter: 'blur(0px)', duration: 0.45, ease: 'power3.out' });
      });
      row.addEventListener('pointerleave', function () {
        gsap.to(npop, { autoAlpha: 0, scale: 0.94, filter: 'blur(7px)', duration: 0.3, ease: 'power2.out' });
      });
      row.addEventListener('pointermove', function (e) {
        npx(Math.min(e.clientX + 28, innerWidth - 290));
        npy(Math.max(16, Math.min(e.clientY - 140, innerHeight - 300)));
      });
    });
  }

  /* ---- 遊び心: ヒーロー浮遊タイルのちょこん+巨大ウォーターマーク視差 ---- */
  if (fine && !reduce) {
    document.querySelectorAll('.nx-hfloat').forEach(function (f) {
      f.addEventListener('pointerenter', function () {
        gsap.fromTo(f, { scale: 1 }, { scale: 1.07, duration: 0.18, yoyo: true, repeat: 1, ease: 'power2.out' });
      });
    });
  }
  /* nx-fcta__mark(naturism透かし)は撤去済のためパララックスも削除(2026-07-11) */

  /* ---- 文脈カーソル ---- */
  var cur = document.getElementById('nxCur');
  if (cur && fine && !reduce) {
    document.body.classList.add('nx-cursor-on');
    var cx = gsap.quickTo(cur, 'x', { duration: 0.16, ease: 'power3' });
    var cy = gsap.quickTo(cur, 'y', { duration: 0.16, ease: 'power3' });
    addEventListener('pointermove', function (e) {
      cx(e.clientX);
      cy(e.clientY);
    });
    addEventListener('pointerdown', function () {
      gsap.to(cur, { scale: 0.82, duration: 0.12 });
    });
    addEventListener('pointerup', function () {
      gsap.to(cur, { scale: 1, duration: 0.3, ease: 'back.out(2.5)' });
    });
    /* 変形状態(ring/view/drag)と暗色反転(inv)は独立管理して合成する(2026-07-11)。
       黒フッター/黒告知バー上でinkドットが消えるため、暗色地帯では白へ反転 */
    var curCls = '';
    var curDark = false;
    var applyCur = function () {
      var c = 'nx-cur';
      if (curCls) c += ' ' + curCls;
      if (curDark) c += ' nx-cur--inv';
      cur.className = c;
    };
    var bind = function (sel, cls) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.addEventListener('pointerenter', function () {
          curCls = cls;
          applyCur();
        });
        el.addEventListener('pointerleave', function () {
          curCls = '';
          applyCur();
        });
      });
    };
    bind('[data-nx-cur="drag"]', 'nx-cur--drag');
    bind('[data-nx-cur="view"], .nx-pcard', 'nx-cur--view');
    bind('a:not([data-nx-cur]):not(.nx-pcard), button:not([data-nx-cur]), summary', 'nx-cur--ring');
    /* 暗色判定はwindowへの上位委譲(バブリング捕捉)。
       個別要素バインドと違い、エディタのセクション再描画でリスナーが失われない */
    addEventListener('pointerover', function (e) {
      var d = !!(e.target.closest && e.target.closest('.footer, .nx-ann'));
      if (d !== curDark) {
        curDark = d;
        applyCur();
      }
    });
  }

  /* ---- アンカーはLenisで滑らかに ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var t = document.querySelector(id);
      if (t && lenis) {
        e.preventDefault();
        lenis.scrollTo(t, { offset: -60 });
      }
    });
  });

  /* ---- hero v2: 缶トリオ・ステージ「Ripple Light + Product Film」(2026-07-02) ----
     プリローダー(nx-preloader)の幕明けと連結して入場。フィルムは実写真のマクロを
     GSAPで撮る(動画ファイル不使用)。旧ヒーローとは !heroV2 ガードで排他。 */
  if (heroV2) {
    /* セレクタは全てheroV2配下にスコープ(エディタ再挿入・複数DOM同居への耐性) */
    var v2q = function (sel) {
      return heroV2.querySelectorAll(sel);
    };
    var v2H1 = heroV2.querySelector('#nxV2H1');
    var v2Sub = heroV2.querySelector('#nxV2Sub');
    var v2Cans = gsap.utils.toArray(v2q('.nxv2-can'));
    var v2DefaultSub = v2Sub ? v2Sub.dataset.default || v2Sub.textContent : '';

    /* H1文字バラし(createElementで分解=innerHTML不使用)。
       読点区切りの折返しセグメント(.nxv2-h1seg=Liquid生成・nowrap)がある場合は
       セグメント構造を保ったまま各セグメント内でバラす(2026-07-13) */
    if (v2H1 && !reduce) {
      var v2SplitChars = function (el) {
        var t = el.textContent;
        el.textContent = '';
        t.split('').forEach(function (c) {
          var s = document.createElement('span');
          s.className = 'nx-ch';
          s.textContent = c === ' ' ? ' ' : c;
          el.appendChild(s);
        });
      };
      var v2Segs = v2H1.querySelectorAll('.nxv2-h1seg');
      if (v2Segs.length) {
        for (var v2si = 0; v2si < v2Segs.length; v2si++) v2SplitChars(v2Segs[v2si]);
      } else {
        v2SplitChars(v2H1);
      }
    }

    /* プリローダー出口の4経路ハンドオフ:
       ①animationend(nxplOut)=主信号 ②後着ロード(既に消えている)
       ③nx-skip/reduced-motion/designMode=即時 ④2000msバックストップ
       (JSフェイルセーフ1700ms/nx-preloader.liquid より後ろに置く・2026-07-20短縮) */
    var whenPreloaderGone = function (cb) {
      var pre = document.getElementById('nx-preloader');
      var fired = false;
      var fire = function () {
        if (!fired) {
          fired = true;
          cb();
        }
      };
      if (
        !pre ||
        document.documentElement.classList.contains('nx-skip') ||
        reduce ||
        (window.Shopify && Shopify.designMode)
      ) {
        fire();
        return;
      }
      var cs = getComputedStyle(pre);
      if (cs.display === 'none' || cs.visibility === 'hidden') {
        fire();
        return;
      }
      var backstop = setTimeout(fire, 2000);
      var onEnd = function (e) {
        if (e.animationName !== 'nxplOut') return;
        pre.removeEventListener('animationend', onEnd);
        clearTimeout(backstop);
        fire();
      };
      pre.addEventListener('animationend', onEnd);
    };

    /* シリーズ色シフト: hover/フォーカス(fine) / タップ選択→再タップで遷移(coarse) */
    var setSeries = function (s) {
      heroV2.dataset.series = s || 'none';
      if (!v2Sub) return;
      var can = s && s !== 'none' ? heroV2.querySelector('.nxv2-can[data-series="' + s + '"]') : null;
      var txt = (can && can.dataset.copy) || v2DefaultSub;
      if (v2Sub.textContent === txt) return;
      if (reduce) {
        v2Sub.textContent = txt;
        return;
      }
      gsap
        .timeline()
        .to(v2Sub, { opacity: 0, y: 6, duration: 0.16, ease: 'power2.out' })
        .add(function () {
          v2Sub.textContent = txt;
        })
        .to(v2Sub, { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' });
    };
    if (fine) {
      v2Cans.forEach(function (can) {
        can.addEventListener('pointerenter', function () {
          setSeries(can.dataset.series);
        });
        can.addEventListener('focus', function () {
          setSeries(can.dataset.series);
        });
      });
      var v2Stage = heroV2.querySelector('#nxV2Stage');
      if (v2Stage)
        v2Stage.addEventListener('pointerleave', function () {
          setSeries('none');
        });
    } else {
      v2Cans.forEach(function (can) {
        can.addEventListener('click', function (e) {
          if (e.detail === 0) return; /* キーボード由来(Enter)は通常遷移 */
          if (heroV2.dataset.series === can.dataset.series) return; /* 2回目タップ=商品へ */
          e.preventDefault();
          setSeries(can.dataset.series);
        });
      });
    }

    /* 入場(幕明けから連続)。センター缶はopacityを触らずtransformのみ=LCP保護 */
    var v2Entrance = gsap.timeline({ paused: true, defaults: { ease: 'power3.out' } });
    if (!reduce) {
      v2Entrance
        .from(v2q('.nxv2-ripples'), { opacity: 0, duration: 1.1, ease: 'power2.out' }, 0)
        .from(
          v2q('.nxv2-can--main'),
          { y: 90, scale: 0.92, duration: 0.95, ease: 'back.out(1.4)', clearProps: 'transform' },
          0.1,
        )
        .from(
          v2q('.nxv2-can--blue, .nxv2-can--pink'),
          {
            y: 70,
            opacity: 0,
            scale: 0.9,
            stagger: 0.12,
            duration: 0.8,
            ease: 'back.out(1.55)',
            clearProps: 'transform,opacity',
          },
          0.3,
        )
        .from(v2q('.nxv2-kicker'), { y: 16, opacity: 0, duration: 0.5, clearProps: 'transform,opacity' }, 0.35)
        .from(v2q('#nxV2H1 .nx-ch'), { y: 22, opacity: 0, stagger: 0.02, duration: 0.6, ease: 'back.out(1.5)' }, 0.45)
        .from(
          /* チップは.nxv2-ctas内へ移設済(2026-07-13)。個別指定すると親子で二重アニメになるため除外 */
          v2q('.nxv2-sub, .nxv2-ctas'),
          { y: 14, opacity: 0, stagger: 0.09, duration: 0.5, clearProps: 'transform,opacity' },
          0.7,
        )
        .from(
          v2q('.nxv2-cap'),
          { opacity: 0, y: 10, stagger: 0.08, duration: 0.5, clearProps: 'transform,opacity' },
          0.9,
        )
        .from(v2q('.nxv2-cue'), { opacity: 0, duration: 0.5 }, 1.0);
    }

    /* Product Film: Premium6割(質感→エンボス→銘板→引き)/Blue・Pink各ビート→ステージ */
    var v2Film = heroV2.querySelector('#nxV2Film');
    var v2FilmDone = false;
    var v2FilmCleanup = null; /* skip系リスナーの解除(スキップ/完走の両経路で呼ぶ) */
    var v2PrevFocus = null;
    var v2StartStage = function () {
      if (v2FilmDone) return;
      v2FilmDone = true;
      if (v2FilmCleanup) v2FilmCleanup();
      if (v2Film && v2Film.classList.contains('is-on')) {
        gsap.to(v2Film, {
          opacity: 0,
          duration: 0.5,
          ease: 'power2.inOut',
          onComplete: function () {
            v2Film.classList.remove('is-on');
            v2Film.style.display = 'none';
          },
        });
        if (v2PrevFocus && v2PrevFocus.focus) v2PrevFocus.focus();
      }
      if (!reduce) v2Entrance.play();
    };

    var v2WantFilm = heroV2.dataset.film === 'true' && v2Film && !reduce && !(window.Shopify && Shopify.designMode);
    try {
      if (v2WantFilm && sessionStorage.getItem('nxV2Film')) v2WantFilm = false;
    } catch (e) {}

    if (v2WantFilm) {
      try {
        sessionStorage.setItem('nxV2Film', '1');
      } catch (e) {}
      /* data-src→src(再生時のみ取得) */
      v2Film.querySelectorAll('.nxv2-film__frame img[data-src]').forEach(function (im) {
        im.src = im.dataset.src;
      });
      var v2Cap = v2Film.querySelector('#nxV2FilmCap');
      var v2SetCap = function (t) {
        if (!v2Cap) return;
        v2Cap.textContent = t;
        gsap.fromTo(v2Cap, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' });
      };
      var v2Frame = function (s) {
        return v2Film.querySelector('.nxv2-film__frame[data-film-can="' + s + '"]');
      };
      v2Film.querySelectorAll('.nxv2-film__frame img').forEach(function (im) {
        gsap.set(im, { xPercent: -50, yPercent: -50 });
      });
      var ftl = gsap.timeline({ paused: true, onComplete: v2StartStage });
      var fP = v2Frame('premium');
      if (fP) {
        var iP = fP.querySelector('img');
        ftl
          .set(fP, { opacity: 1 })
          .call(function () {
            v2SetCap('PREMIUM');
          })
          /* 静: 金属の質感からnエンボスへゆっくり */
          .fromTo(
            iP,
            { scale: 2.5, xPercent: -46, yPercent: -34 },
            { xPercent: -50, yPercent: -42, duration: 1.6, ease: 'sine.inOut' },
          )
          /* 動: 銘板(27 TABLETS / 3 DAYS)へ寄る */
          .to(iP, { scale: 2.9, xPercent: -56, yPercent: -63, duration: 0.55, ease: 'power3.inOut' })
          /* 静: 細部を見せる */
          .to(iP, { xPercent: -54, yPercent: -65, duration: 0.9, ease: 'sine.inOut' })
          /* 引き */
          .to(iP, { scale: 0.92, xPercent: -50, yPercent: -50, duration: 0.7, ease: 'power3.inOut' })
          .to(fP, { opacity: 0, duration: 0.28 }, '>-0.05');
      }
      var fB = v2Frame('blue');
      if (fB) {
        var iB = fB.querySelector('img');
        ftl
          .set(fB, { opacity: 1 })
          .call(function () {
            v2SetCap('BLUE');
          })
          .fromTo(
            iB,
            { scale: 2.3, xPercent: -44, yPercent: -40 },
            { xPercent: -52, yPercent: -44, duration: 0.75, ease: 'power2.out' },
          )
          .to(fB, { opacity: 0, duration: 0.22 });
      }
      var fK = v2Frame('pink');
      if (fK) {
        var iK = fK.querySelector('img');
        ftl
          .set(fK, { opacity: 1 })
          .call(function () {
            v2SetCap('PINK');
          })
          .fromTo(
            iK,
            { scale: 2.3, xPercent: -56, yPercent: -40 },
            { xPercent: -48, yPercent: -44, duration: 0.75, ease: 'power2.out' },
          )
          .to(fK, { opacity: 0, duration: 0.25 });
      }
      var v2Skip = function () {
        if (v2FilmDone) return;
        ftl.kill();
        v2StartStage();
      };
      /* Tab/IME等でスキップしないようキーを限定 */
      var v2KeySkip = function (e) {
        if (e.key === 'Escape' || e.key === 'Enter' || e.key === ' ') v2Skip();
      };
      var v2SkipBtn = v2Film.querySelector('#nxV2FilmSkip');
      if (v2SkipBtn) v2SkipBtn.addEventListener('click', v2Skip);
      addEventListener('wheel', v2Skip, { passive: true });
      addEventListener('touchmove', v2Skip, { passive: true });
      addEventListener('keydown', v2KeySkip);
      v2FilmCleanup = function () {
        removeEventListener('wheel', v2Skip);
        removeEventListener('touchmove', v2Skip);
        removeEventListener('keydown', v2KeySkip);
      };
      v2Film.classList.add('is-on');
      whenPreloaderGone(function () {
        /* 再生中は背面へのTab抜けを防ぐためSKIPへフォーカス(終了時に復帰) */
        v2PrevFocus = document.activeElement;
        if (v2SkipBtn) v2SkipBtn.focus({ preventScroll: true });
        ftl.play();
      });
    } else {
      whenPreloaderGone(v2StartStage);
    }

    /* ドック退場: 左右の缶は外へ、センター缶はヘッダー方向へ縮小=本編への吸い込み。
       モバイル(≤989px=缶ファーストの縦長レイアウト)ではコピー/キャプション/キューの
       フェードをヒーロー進行から切り離し、各要素の下端が画面上部(38%→8%)を通過する
       間だけ消す=CTAは読める位置では常に不透明・去り際だけ白ボケ
       (2026-07-21オーナー指示「白ボケを大幅遅延」。端末高さ非依存の位置基準で実装) */
    if (heroV2.dataset.dock === 'true' && !reduce) {
      var v2DockCans = function (tl) {
        tl.to(v2q('.nxv2-can--blue'), { xPercent: -70, y: -140, opacity: 0, ease: 'none', duration: 1 }, 0)
          .to(v2q('.nxv2-can--pink'), { xPercent: 70, y: -140, opacity: 0, ease: 'none', duration: 1 }, 0)
          .to(
            v2q('.nxv2-can--main'),
            { scale: 0.3, yPercent: -150, transformOrigin: '50% 0%', ease: 'none', duration: 1 },
            0,
          )
          .to(v2q('.nxv2-can--main'), { opacity: 0, ease: 'none', duration: 0.3 }, 0.7);
        return tl;
      };
      var v2DockMM = gsap.matchMedia();
      v2DockMM.add('(min-width:990px)', function () {
        v2DockCans(
          gsap.timeline({
            scrollTrigger: { trigger: heroV2, start: 'top top', end: '65% top', scrub: true },
          }),
        )
          .to(v2q('.nxv2-copy'), { opacity: 0, y: -40, ease: 'none', duration: 1 }, 0)
          .to(v2q('.nxv2-cap'), { opacity: 0, ease: 'none', duration: 0.6 }, 0)
          /* キューはスクラブ前半を耐えて後半で退場(開始0.35・即消え防止 2026-07-19) */
          .to(v2q('.nxv2-cue'), { opacity: 0, ease: 'none', duration: 0.65 }, 0.35);
      });
      v2DockMM.add('(max-width:989px)', function () {
        v2DockCans(
          gsap.timeline({
            scrollTrigger: { trigger: heroV2, start: 'top top', end: '65% top', scrub: true },
          }),
        );
        /* ⚠️ヒーロー本体は.nxv2-sticky(100svh)が貼り付く構造のため、要素自身をtriggerにすると
           refresh時の静的座標基準で早すぎるフェードになる(実測)。sticky解除後に要素下端が
           画面上部38%→8%を通過する瞬間を「HERO下端の到達位置」へ換算して発火する */
        var v2Stage = heroV2.querySelector('.nxv2-sticky') || heroV2;
        Array.prototype.forEach.call(heroV2.querySelectorAll('.nxv2-copy,.nxv2-cap,.nxv2-cue'), function (el) {
          var inStageBottom = function () {
            return el.getBoundingClientRect().bottom - v2Stage.getBoundingClientRect().top;
          };
          gsap.to(el, {
            opacity: 0,
            y: -24,
            ease: 'none',
            scrollTrigger: {
              trigger: heroV2,
              start: function () {
                return (
                  'bottom ' + Math.round(v2Stage.offsetHeight - inStageBottom() + window.innerHeight * 0.38) + 'px'
                );
              },
              end: function () {
                return (
                  'bottom ' + Math.round(v2Stage.offsetHeight - inStageBottom() + window.innerHeight * 0.08) + 'px'
                );
              },
              scrub: true,
            },
          });
        });
      });
    }
  }

  /* 定期便ベネフィット3カード: 視界進入で1枚ずつポップイン(2026-07-13・浮遊bob廃止)。
     no-JS/reduce/エディタでは初期状態のまま可視(fromツイーンなので隠し損ねが起きない) */
  var subscPerks = document.querySelectorAll('.nx-subsc__perk');
  if (subscPerks.length && !reduce && !(window.Shopify && Shopify.designMode)) {
    gsap.from(subscPerks, {
      y: 22,
      scale: 0.82,
      opacity: 0,
      duration: 0.55,
      stagger: 0.13,
      ease: 'back.out(1.8)',
      clearProps: 'transform,opacity',
      scrollTrigger: { trigger: '.nx-subsc__perks', start: 'top 84%', once: true },
    });
  }

  /* ⚠️ピンスペーサー挿入後に全トリガー座標を再計算(無いとピンより下の
     波/出現のstart-endが約2画面分ズレて固着する=プロトタイプ実測済) */
  ScrollTrigger.sort();
  ScrollTrigger.refresh();
  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      ScrollTrigger.refresh();
    });
  }
})();
